import { LOAD_COMPROMISSOS, PDG_TOGGLE_LOADING, SET_COMPROMISSOS_SECRETARIA, SET_LOADING_SECRETARIA } from './types'

export const mutations = {
  [LOAD_COMPROMISSOS]: (state, payload) => {
    state.compromissos = [...payload]
  },
  [PDG_TOGGLE_LOADING]: state => {
    state.loading = !state.loading
  },
  [SET_COMPROMISSOS_SECRETARIA]: (state, payload) => {
    state.compromissosSecretaria = [...payload]
  },
  [SET_LOADING_SECRETARIA]: (state, payload) => {
    state.loadingSecretaria = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/plano_governo/mutations.js